import { Badge } from 'components/ui/badge';
import { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { cn } from 'utils/cn';

interface Props extends Omit<ComponentProps<typeof Badge>, 'children'> {
    count: number;
}

/** "+N more", styled like a selected value in a multi-select. Other props reach the badge, so it can be a tooltip trigger. */
export default function NMoreChip({ count, className, ...restProps }: Props) {
    return (
        <Badge
            variant="outline"
            className={cn(
                'bg-grey-100 border-grey-300 text-fg h-auto rounded-sm px-1.5 py-0.5 text-sm font-normal',
                className
            )}
            {...restProps}
        >
            <FormattedMessage id="plus-n-more" values={{ count }} />
        </Badge>
    );
}
